import { configureStore } from "@reduxjs/toolkit";

import { persistStore, persistReducer } from "redux-persist";

import thunk from "redux-thunk";
import { combineReducers } from "redux";
import { createLogger } from "redux-logger";
import storage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";

import settingsReducer from "./features/settings";
import modalsReducer from "./features/modals";
import breadcrumbsReducer from "./features/breadcrumbs";
import systemConfigs from "./features/systemConfigs";
import sessionReducer from "./features/session";

const sessionPersistedReducer = persistReducer(
    {
        key: "session",
        storage: sessionStorage,
    },
    sessionReducer
);

const persistedReducer = persistReducer(
    {
        key: "root",
        storage: storage,
        whitelist: ["settings"],
        blacklist: ["session"],
    },
    combineReducers({
        settings: settingsReducer,
        modals: modalsReducer,
        breadcrumbs: breadcrumbsReducer,
        systemConfigs: systemConfigs,
        session: sessionPersistedReducer,
    })
);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk, createLogger()],
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
